import { CreditCard } from 'lucide-react';
import { useMemo } from 'react';
import { StepHeader } from '~/components/forms/StepHeader';
import { TuitionChunk } from '~/components/form-chunks/TuitionChunk';
import { useEnrollingStudents } from '~/hooks/useEnrollingStudents';

/**
 * TuitionStep - Select tuition option for each student and payment plan for the family.
 * Delegates to TuitionChunk for the actual form content.
 */
export function TuitionStep({ formData, tuitionOptions: propTuitionOptions = [], paymentOptions: propPaymentOptions = [], schoolYearStartDate: propSchoolYearStartDate, schoolYearEndDate: propSchoolYearEndDate, updateFormData }: any) {
  // Use embedded availableOptions from formData if available, otherwise fall back to props
  const availableOptions = formData?.availableOptions || {};
  const tuitionOptions = availableOptions.tuitionOptions?.length > 0
    ? availableOptions.tuitionOptions
    : propTuitionOptions;
  const paymentOptions = availableOptions.paymentOptions?.length > 0
    ? availableOptions.paymentOptions
    : propPaymentOptions;

  // School year dates - from formData.schoolYear (metadata) or props (fallback)
  const schoolYear = formData?.schoolYear || {};
  const schoolYearStartDate = schoolYear.startDate || propSchoolYearStartDate;
  const schoolYearEndDate = schoolYear.endDate || propSchoolYearEndDate;

  const tuitionPreferences = useMemo(() => formData?.tuitionPreferences || {}, [formData?.tuitionPreferences]);

  const enrollingStudents = useEnrollingStudents(formData);

  const handleUpdate = (updatedTuitionPreferences: any) => {
    updateFormData('tuitionPreferences', updatedTuitionPreferences);
  };

  return (
    <div className="space-y-6">
      <StepHeader
        icon={CreditCard}
        title="Tuition & Payment"
        description="Select a tuition option for each student and a payment plan for your family."
      />

      <TuitionChunk
        enrollingStudents={enrollingStudents}
        tuitionOptions={tuitionOptions}
        paymentOptions={paymentOptions}
        tuitionPreferences={tuitionPreferences}
        onUpdate={handleUpdate}
        schoolYearStartDate={schoolYearStartDate}
        schoolYearEndDate={schoolYearEndDate}
      />
    </div>
  );
}

export default TuitionStep;
